import React, {useState} from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {CancellationModificationRefundContent} from "../Components/cancellationModificationRefund.jsx";
import {storage, STORAGE_KEYS} from "@/utils/storage";

// Mobile step for the Cancellation / Modification / Refund tabbed popup (desktop
// renders it inline as an .upper-modal in selectedCarDetailsLatest + orderDetails).
// Reuses the same content component — only the shell differs. It's in POPUP_STEPS,
// so on mobile it opens as a stacked overlay and the X pops back to the step below.
export function CancellationModificationRefund(props) {
    // Deep-link support: the "Refund" policies row stamps CMR_INITIAL_TAB before
    // navigating. Read it ONCE and clear it, so reopening elsewhere defaults to
    // Cancellation. (Booking flow only — this step is never used on trip pages.)
    const [initialTab] = useState(() => {
        const tab = storage.get(STORAGE_KEYS.CMR_INITIAL_TAB) || 'cancellation';
        storage.remove(STORAGE_KEYS.CMR_INITIAL_TAB);
        return tab;
    });

    return (
        <>
            <ModalHeader
                title=""
                buttonStyle="elegant"
                extraClasses=""
                totalSteps={0}
                cancelButton={true}
                // elegant doesn't imply a close type the way modern did — pass it.
                cancelButtonType="icon"
                ignoreEditMode={true}
                showBackButton={false}
                setStep={props.setStep}
                closeModal={props.closeModal}
            />

            <div className="modalPages-spacing padding-bottom-30">
                <CancellationModificationRefundContent initialTab={initialTab}/>
            </div>
        </>
    );
}

export default CancellationModificationRefund;
